import I18n from "../../I18n";

export const familyBySeverity = (severity) => {
    switch (severity) {
        case 0:
            return "success";
        case 1:
            return "warning";
        case 2:
        case 3:
            return "error";
        default:
            break;
    }
};

const header = [
    {
        label: ["Description"],
        align: "left",
        field: "description",
        flex: 2,
        type: "string",
    },
    { label: ["Identifier"], align: "left", field: "ruleId", flex: 1, type: "string" },
    { label: ["Rule Type"], align: "left", field: "ruleType", flex: 1, type: "string" },
    {
        label: ["Severity"],
        align: "left",
        field: "severity",
        type: "status",
        basis: "20%",
        renderCard: true,
    },
    { label: ["Entity"], type: "string", align: "left", field: "entity", flex: 1 },
    {
        label: ["Number Of Occurrences"],
        type: "number",
        align: "right",
        field: "numberOfOccurrences",
        flex: 1,
    },
];

//TODO check if we need labels
export const mapCard = (json) => {
    const { DescriptionPreview, RuleID, Severity, RuleType, Entity, NumberOfFindings } = json;

    const referenceTypeFormated = Entity ? Entity.split("::").pop() : null;

    return [
        [
            {
                labels: ["description"],
                value: DescriptionPreview,
            },
        ],
        [{ labels: ["rule_id"], value: RuleID, column: "ruleId" }],
        [{ labels: ["rule_type"], value: RuleType, column: "ruleType", align: "left" }],
        [
            {
                labels: ["severity"],
                value: {
                    value: `severity-${Severity}`,
                    label: I18n.translate`${`severity-${Severity}`}`,
                    aligment: "center",
                    severity: Severity,
                    color: "main",
                    family: familyBySeverity(Severity),
                },
                column: "severity",
            },
        ],
        [
            {
                labels: ["entity"],
                value: referenceTypeFormated
                    ? I18n.translate("reference_" + referenceTypeFormated)
                    : "",
                align: "center",
                column: "entity",
            },
        ],
        [
            {
                labels: ["NumberOfFindings"],
                value: NumberOfFindings,
                align: "center",
                column: "numberOfOccurrences",
            },
        ],
    ];
};

const mapper = (json, card) => {
    const name = json.name;
    const total = json.total;
    return {
        ...json,
        __typename: json.__typename,
        name,
        total,
        shortName: name,
        card: card ? mapCard(json) : [],
        link: {
            to: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit${
                json.ModulePrefixByFileType ? "/" + json.ModulePrefixByFileType : ""
            }/rules/${json.id}`,
        },
    };
};

const ncrulefindingMapper = {
    map: mapper,
    header,
};

export default ncrulefindingMapper;
